<div class="prediction-rota-switch">
  <div [ngClass]="{'inactive': isActiveRotaPage(), 'active': !isActiveRotaPage()}">
    <a routerLink="/footfall-week/{{weekId()}}">Predictions</a>
  </div>
  <div [ngClass]="{'inactive': !isActiveRotaPage(), 'active': isActiveRotaPage()}">
    <a routerLink="/rota-week/{{weekId()}}" [ngClass]="{'link-disabled': !rotaExist()}">Rota</a>
  </div>
</div>